import { render, staticRenderFns } from "./DispatcherReportsList.vue?vue&type=template&id=355f96d0&"
import script from "./DispatcherReportsList.vue?vue&type=script&lang=js&"
export * from "./DispatcherReportsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports